/**
 * Clive: open the Intercom messenger when a visitor lands on the contact page.
 *
 * Previously this delegated clicks on /pages/contact links and called
 * Intercom('show') INSTEAD of navigating (event.preventDefault). That meant the
 * contact page itself was almost never seen — the footer link, the Support
 * meganav and the page's own Live Chat CTA all dead-ended in the messenger.
 * Now both happen: the link navigates normally, and the messenger opens once the
 * page has loaded, so the showroom address, hours and contact routes are on
 * screen behind it.
 *
 * Intercom loads asynchronously via its app embed, so poll briefly rather than
 * assuming it is ready. If it never loads — ad blockers do block it — nothing
 * happens and the visitor still has the full contact page, which is the point.
 */
(function () {
  'use strict';

  var CONTACT = /\/pages\/contact\/?$/;
  var POLL_MS = 250;
  var TIMEOUT_MS = 8000;

  if (!CONTACT.test(window.location.pathname)) return;

  var waited = 0;
  var timer = setInterval(function () {
    if (typeof window.Intercom === 'function') {
      clearInterval(timer);
      try {
        window.Intercom('show');
      } catch (e) {
        /* messenger unavailable — the contact page stands on its own */
      }
      return;
    }
    waited += POLL_MS;
    if (waited >= TIMEOUT_MS) clearInterval(timer);
  }, POLL_MS);
})();
